import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

const styles = {
  info: { box: 'bg-primary-soft text-primary border-primary/20', icon: Info },
  success: { box: 'bg-success-soft text-success border-success/20', icon: CircleCheck },
  warning: { box: 'bg-warning-soft text-warning border-warning/20', icon: TriangleAlert },
  danger: { box: 'bg-destructive-soft text-destructive border-destructive/20', icon: CircleAlert },
}

export function Alert({
  tone = 'info',
  children,
  className,
}: {
  tone?: keyof typeof styles
  children: React.ReactNode
  className?: string
}) {
  const { box, icon: Icon } = styles[tone]
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn('flex items-start gap-2 rounded-md border px-3 py-2 text-sm', box, className)}
    >
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div>{children}</div>
    </div>
  )
}
